import { Typography } from '@material-ui/core';
import React from 'react';
import Webcam from 'react-webcam';

export const WebCam = () => {
  return (
    <div style={{ paddingTop: '20px' }}>
      {/* <Typography
        variant="h6"
        style={{ fontSize: 18, fontWeight: 'bold', textTransform: 'uppercase' }}
      >
        Faculty Proctoring Screen
      </Typography>{' '} */}
      <Webcam width={1150} height={520} />,
    </div>
  );
};
